import {
  Button,
  Card,
  CardContent,
  CardHeader,
  IconButton,
  InputAdornment,
  makeStyles,
  TextField,
} from "@material-ui/core";
import { Save, Visibility, VisibilityOff } from "@material-ui/icons";
import React, { useState } from "react";
import Loading from "../components/Loading";
import { usePopups } from "../contexts/PopupContext";
import { useGlobalSnackbar } from "../contexts/SnackbarContext";
import useApi from "../hooks/useApi";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  content: {
    margin: "auto",
    display: "flex",
    minHeight: "100vh",
    justifyContent: "center",
    alignItems: "center",
  },
  card: {
    width: "min(40rem, 80vw)",
  },
  cardTitle: {
    textAlign: "left",
  },
  field: {
    paddingBottom: ".5rem",
  },
  button: {
    width: "100%",
  },
});

const ShowButton = ({ show, onClick }) => {
  return (
    <InputAdornment position="end">
      <IconButton aria-label="toggle password visibility" onClick={onClick}>
        {!show ? <Visibility /> : <VisibilityOff />}
      </IconButton>
    </InputAdornment>
  );
};

const Profile = (props) => {
  const classes = useStyles();
  const { t } = useTranslation(["views", "common"]);
  const [loading, setLoading] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const setGlobalSnackbar = useGlobalSnackbar();

  const api = useApi();

  const [, open] = usePopups();

  const updatePassword = async (e) => {
    e.preventDefault();
    if (confirmPassword !== password) {
      setGlobalSnackbar({
        open: true,
        severity: "error",
        message: `${t("common:errors.update_password")}`,
      });
      return;
    }
    setLoading(true);
    const res = await api(
      "users",
      "PATCH",
      {
        password,
        oldPassword,
      },
      () => {
        open("sessionExpiredPopup");
      },
    );
    setLoading(false);
    if (res.ok === false) {
      setGlobalSnackbar({
        open: true,
        severity: "error",
        message: `${t("common:errors.general_update_password")}`,
      });
      return;
    }
    setGlobalSnackbar({
      open: true,
      severity: "success",
      message: `${t("common:success.update_password")}.`,
    });
  };

  return (
    <div className={classes.content}>
      <Loading loading={loading} />
      <Card className={classes.card}>
        <CardHeader
          title={t("views:profile.change_password")}
          className={classes.cardTitle}
        />
        <CardContent>
          <form onSubmit={updatePassword}>
            <div className={classes.field}>
              <TextField
                fullWidth
                type={showOldPassword ? "text" : "password"}
                id="Old Password"
                label={t("common:label.old_password")}
                InputProps={{
                  endAdornment: (
                    <ShowButton
                      show={showOldPassword}
                      onClick={() => setShowOldPassword((prev) => !prev)}
                    />
                  ),
                }}
                required
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
              />
            </div>
            <div className={classes.field}>
              <TextField
                fullWidth
                type={showPassword ? "text" : "password"}
                id="Nuova Password"
                label={t("common:label.new_password")}
                required
                InputProps={{
                  endAdornment: (
                    <ShowButton
                      show={showPassword}
                      onClick={() => setShowPassword((prev) => !prev)}
                    />
                  ),
                }}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <div className={classes.field}>
              <TextField
                fullWidth
                type={showConfirmPassword ? "text" : "password"}
                id="Conferma Password"
                label={t("common:label.confirm_password")}
                required
                InputProps={{
                  endAdornment: (
                    <ShowButton
                      show={showConfirmPassword}
                      onClick={() => setShowConfirmPassword((prev) => !prev)}
                    />
                  ),
                }}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </div>
            <div>
              <Button
                type="submit"
                className={classes.button}
                variant="contained"
                color="primary"
                endIcon={<Save />}
              >
                {t("common:button.refresh_password")}
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};
export default Profile;
